import { render } from "./StockElement.vue?vue&type=template&id=3f93799f"
import script from "./StockElement.vue?vue&type=script&lang=js"
export * from "./StockElement.vue?vue&type=script&lang=js"

import "./StockElement.vue?vue&type=style&index=0&id=3f93799f&lang=css"
script.render = render

export default script